import { mapState } from 'vuex';
import marked from 'marked';
import { sanitize } from '@/lib/utils.js';

const handleTranslatedInputMixin = {
  methods: {
    handleTranslatedInput(
      property,
      translated,
      markdown = false,
      translateProperty = true
    ) {
      const payload = { translated };

      if (translateProperty) {
        const translatedProperty = (translated[this.locale] || {})[property] || '';
        payload[property] = markdown ? sanitize(this.marked(translatedProperty)) : translatedProperty;
      }

      this.$emit('input', payload);
    }
  },
  computed: {
    ...mapState('global', ['supportedLanguages']),
    locale() {
      return this.supportedLanguages.some(
          language => language === this.lang.locale
      )
          ? this.lang.locale
          : this.lang.fallback;
    }
  },
  mounted() {
    this.marked = marked;
    this.marked.setOptions({ breaks: true });
  }
};

export default handleTranslatedInputMixin;
